import React from 'react';
import { motion } from 'framer-motion';
export function Solution() {
  return <section className="py-8 md:py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center" data-id="element-169">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="relative" data-id="element-170">
        <div className="absolute inset-0 bg-accent-cyan/5 blur-[100px] rounded-full" data-id="element-171"></div>
        <div className="relative z-10" data-id="element-172">
          <h2 className="text-3xl md:text-5xl font-bold mb-3 md:mb-4" data-id="element-173">
            Con Química 360, la improvisación se termina.
          </h2>
          <h3 className="text-xl md:text-2xl text-accent-cyan font-medium mb-3 md:mb-5" data-id="element-174">
            Tenés el año técnico resuelto. Literalmente.
          </h3>
          <p className="text-base md:text-lg text-text-muted leading-relaxed max-w-3xl mx-auto" data-id="element-175">
            Presentamos el{' '}
            <strong className="text-text-main" data-id="element-176">
              MegaPack Química Aplicada
            </strong>
            : El primer sistema didáctico situado en la realidad del técnico
            profesional.
          </p>
        </div>
      </motion.div>
    </section>;
}